import { useCallback, useRef, useState } from 'react'

const usePaymentState = () => {
  const activePaymentMethodRef = useRef(null)
  const [activePaymentMethod, setActivePaymentMethod] = useState(null)

  const hasPaymentInProgress = useCallback(() => {
    return Boolean(activePaymentMethodRef.current)
  }, [])

  const startPayment = useCallback((method) => {
    if (activePaymentMethodRef.current === method) {
      return true
    }

    if (activePaymentMethodRef.current !== null) {
      return false
    }

    activePaymentMethodRef.current = method
    setActivePaymentMethod(method)
    return true
  }, [])

  const completePayment = useCallback((method) => {
    if (activePaymentMethodRef.current !== method) {
      return false
    }

    activePaymentMethodRef.current = null
    setActivePaymentMethod(null)
    return true
  }, [])

  return {
    activePaymentMethod,
    isPaymentInProgress: Boolean(activePaymentMethod),
    hasPaymentInProgress,
    startPayment,
    completePayment,
  }
}

export default usePaymentState
